import React from 'react';
import ReactDOM from 'react-dom';
import '@crema/services';
// import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client'

import App from './App';
import reportWebVitals from './reportWebVitals';

// Sentry.init({
//     dsn: 'https://0e88e853c4604bb2877b14f4757c0f5c@newsentry.armsolusi.com/58',
//     tracesSampleRate: 1.0,
//     tracePropagationTargets: ["localhost", "https://apigw.kubekkp.coofis.com/"],
//     replaysSessionSampleRate: 0.1,
//     replaysOnErrorSampleRate: 1.0,
// })
var tag = document.createElement('script');
tag.async = true;
tag.src = '/assets/script/embeddinglib.js';
var body = document.getElementsByTagName('body')[0];
body.appendChild(tag)
const domNode = document.getElementById('root');
const root = createRoot(domNode);
root.render(<App />)
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
